import i18next from 'i18next'
import React, { ChangeEvent, isValidElement } from 'react'
import { FormCheckbox } from '../form-checkbox'
import styles from './FormMultiSelect.module.css'
import { FormSelect, FormSelectProps } from './FormSelect'
import { FormSelectHeaderItem } from './FormSelectHeaderItem'
import { FormSelectItem } from './FormSelectItem'

export interface Props extends FormSelectProps {
  displaySelectAll?: boolean
  isLoading?: boolean
  isAllSelected: boolean
  selectAllLabel?: string
  onSelectAll: (event: ChangeEvent<HTMLInputElement>) => void
}

export const FormMultiSelect = ({
  isAllSelected,
  children,
  displaySelectAll = true,
  selectAllLabel = i18next.t('glow.selectAll'),
  onSelectAll,
  ...props
}: Props) => {
  const numberOfChildren = React.Children.toArray(children).filter(
    (child) => !isValidElement(child) || child.type !== FormSelectHeaderItem
  ).length
  return (
    <FormSelect multi {...props}>
      {displaySelectAll && (
        <FormSelectItem>
          <FormCheckbox
            checked={isAllSelected}
            label={`${selectAllLabel} (${numberOfChildren})`}
            onChange={onSelectAll}
          />
        </FormSelectItem>
      )}
      {numberOfChildren > 0 && displaySelectAll && <div className={styles.divider} />}
      {children}
    </FormSelect>
  )
}
